import {
  UserNotification,
  UserNotificationListRequestFilter,
  UserNotificationListRequestSorting,
} from 'modules/domain/userNotifications/types'
import { apiClient } from 'modules/utils/httpClient'
import { endpoints } from 'modules/endpoints'
import { ListResponse } from 'types/api'

export const getUserNotificationsList = (
  filter: UserNotificationListRequestFilter,
  sorting: UserNotificationListRequestSorting,
  page: number,
  pageSize?: number,
) => {
  try {
    return apiClient.get<ListResponse<UserNotification>>(endpoints.userNotifications(), {
      ...filter,
      ...sorting,
      page: page,
      page_size: pageSize,
    })
  } catch (err) {
    console.error('User notifications list fetch error!', err)
    throw err
  }
}

export const getUserNotification = (id: string) => {
  try {
    return apiClient.get<UserNotification>(endpoints.userNotifications(id))
  } catch (err) {
    console.error('User notification fetch error!', err)
    throw err
  }
}

export const dismissUserNotification = (userNotificationId: string) => {
  try {
    return apiClient.post<{ success: boolean; message: string }>(
      `${endpoints.userNotifications(userNotificationId)}/dismiss_notification`,
    )
  } catch (err) {
    console.error('User notification dismiss error!', err)
    throw err
  }
}
